<template>
    <div>
        <div class="modal hide fade" id="modalProductCostList" tabindex="-1" role="dialog" aria-labelledby="modalProductCostList" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Sync COGS</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label for="cost_date" class="col-sm-3 col-form-label text-left">Sync Date</label>
                                    <div class="col-sm-3">
                                        <datetime v-model="cost_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="company_no" class="col-sm-3 col-form-label text-left">Company Date</label>
                                    <div class="col-sm-3">
                                        <select v-model="company_no" class="form-control">
                                            <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-hard-primary" data-dismiss="modal" >Cancel</button>
                        <button type="button" class="btn btn-soft-primary" data-dismiss="modal" @click="save">Save</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal hide fade" id="modalProductCost" tabindex="-1" role="dialog" aria-labelledby="modalProductCost" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">COGS List</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-responsive">
                            <div class="form-inline">
                              <select v-model="company" class="btn btn-sm btn-soft-outline-primary">
                                <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                              </select>
                            </div>
                            <table class="table table-item mb-0 table-sm table-hover table-striped">
                              <thead>
                                <tr>
                                  <th style="background-color: #244854; color: white;" class="text-center"></th>
                                  <th colspan="4" class="text-center" style="background-color: #1A1A2E; color: white;">Masuk</th>
                                  <th colspan="4" class="text-center" style="background-color: #3d3d75; color: white;">Keluar</th>
                                  <th colspan="4" class="text-center" style="background-color: #6092a3; color: white;">Saldo</th>
                                </tr>
                                <tr>
                                  <th style="background-color: #244854; color: white;" class="text-center">Date</th>
                                  <!-- Stock Masuk -->
                                  <th style="background-color: #1A1A2E; color: white;">Qty</th>
                                  <th style="background-color: #1A1A2E; color: white;">Uom</th>
                                  <th style="background-color: #1A1A2E; color: white;">Price</th>
                                  <th style="background-color: #1A1A2E; color: white;">Ref No</th>
                                  <!-- Stock Keluar -->
                                  <th style="background-color: #3d3d75; color: white;">Qty</th>
                                  <th style="background-color: #3d3d75; color: white;">Uom</th>
                                  <th style="background-color: #3d3d75; color: white;">Price</th>
                                  <th style="background-color: #3d3d75; color: white;">Ref No</th>
                                  <!-- Stock Saldo -->
                                  <th style="background-color: #6092a3; color: white;">Qty</th>
                                  <th style="background-color: #6092a3; color: white;">Uom</th>
                                  <th style="background-color: #6092a3; color: white;">Price</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="c in groupCost" :key="c.id">
                                  <td><b>{{ c.date | dateFormat('DD/MM/YYYY') }}</b></td>
                                  <td><span v-if="c.qtyIn !== 0">{{ c.qtyIn }}</span></td>
                                  <td>{{ c.uomIn }}</td>
                                  <td><span v-if="c.priceIn !== 0">{{ c.priceIn | currency }}</span></td>
                                  <td>
                                    <span v-for="(r, index) in c.refNoIn" :key="index">
                                      <span v-if="r.status === 'inventory'" style="color: blue; cursor: pointer;" @click="showInventoryNo(r.ref_no)" data-toggle="modal" data-target="#modalInventoryForm" data-backdrop="static" data-keyboard="false">{{ r.ref_no }},</span>
                                      <span v-else style="color: blue; cursor: pointer;" @click="showPurchasingNo(r.ref_no)" data-toggle="modal" data-target="#modalPurchasing" data-backdrop="static" data-keyboard="false">{{ r.ref_no }},</span>
                                    </span>
                                  </td>
                                  <td><span v-if="c.qtyOut !== 0">{{ c.qtyOut }}</span></td>
                                  <td>{{ c.uomOut }}</td>
                                  <td><span v-if="c.priceOut !== 0">{{ c.priceOut | currency }}</span></td>
                                  <td>
                                    <span v-for="(r, index) in c.refNoOut" :key="index">
                                      <span v-if="r.status === 'manufacture material'" style="color: blue; cursor: pointer;" @click="showManufactureNo(r.ref_no)">{{ r.ref_no }}, </span>
                                      <span v-else-if="r.status === 'sales'" style="color: blue; cursor: pointer;" @click="showSaleNo(r.ref_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ r.ref_no }}, </span>
                                    </span>
                                  </td>
                                  <td>{{ c.qtySaldo }}</td>
                                  <td>{{ c.uomSaldo }}</td>
                                  <td>{{ c.priceSaldo | currency }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="row">
                        <div class="col-md-6"><pre>{{ groupCost }}</pre></div>
                        <div class="col-md-6"><pre>{{ productCostByNo }}</pre></div>
                      </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProductCostListModal',
  props: ['company'],
  data () {
    var date = new Date().toISOString()
    return {
      cost_date: date,
      company_no: null
    }
  },
  computed: {
    ...mapState({
      productCostByNo: state => state.products.productCostByNo,
      authUser: state => state.users.authUser,
      companyList: state => state.companies.companyList
    }),
    groupCost () {
      var result = []
      if (this.productCostByNo.length > 0) {
        this.productCostByNo.filter(d => d.company_no === this.company).reduce(function (res, value) {
          console.log('reduce')
          if (!res[value.cost_date]) {
            var qtyIn = 0
            var qtyOut = 0
            var qtySaldo = 0
            var uomIn = null
            var uomOut = null
            var uomSaldo = null
            var priceIn = 0
            var priceOut = 0
            var priceSaldo = 0
            var refNoIn = []
            var refNoOut = []
            if (value.type === 'in') {
              console.log('value type in')
              console.log(value)
              qtyIn = value.cost_qty
              uomIn = value.uom_id
              priceIn = value.cost_amount
              refNoIn.push({
                ref_no: value.ref_no,
                status: value.status
              })
            } else if (value.type === 'out') {
              console.log('value type out')
              console.log(value)
              qtyOut = value.cost_qty
              uomOut = value.uom_id
              priceOut = value.cost_amount
              refNoOut.push({
                ref_no: value.ref_no,
                status: value.status
              })
            } else if (value.type === 'saldo') {
              console.log('value type saldo/current ')
              console.log(value)
              qtySaldo = value.cost_qty
              uomSaldo = value.uom_id
              priceOut = value.cost_average
            }
            res[value.cost_date] = {
              date: value.cost_date,
              qtyIn: qtyIn,
              uomIn: uomIn,
              priceIn: priceIn,
              refNoIn: refNoIn,
              qtyOut: qtyOut,
              uomOut: uomOut,
              priceOut: priceOut,
              refNoOut: refNoOut,
              qtySaldo: qtySaldo,
              uomSaldo: uomSaldo,
              priceSaldo: priceSaldo
            }
            result.push(res[value.cost_date])
          } else {
            if (value.type === 'in') {
              console.log('value type in')
              res[value.cost_date].qtyIn = parseFloat(res[value.cost_date].qtyIn) + parseFloat(value.cost_qty)
              res[value.cost_date].priceIn = value.cost_amount
              res[value.cost_date].uomIn = value.uom_id
              res[value.cost_date].refNoIn.push({
                ref_no: value.ref_no,
                status: value.status
              })
            } else if (value.type === 'out') {
              console.log('value type out')
              res[value.cost_date].qtyOut = parseFloat(res[value.cost_date].qtyOut) + parseFloat(value.cost_qty)
              res[value.cost_date].priceOut = value.cost_amount
              res[value.cost_date].uomOut = value.uom_id
              res[value.cost_date].refNoOut.push({
                ref_no: value.ref_no,
                status: value.status
              })
            } else if (value.type === 'saldo') {
              console.log('value type saldo/current ')
              res[value.cost_date].qtySaldo = parseFloat(value.cost_qty)
              res[value.cost_date].uomSaldo = value.uom_id
              res[value.cost_date].priceSaldo = value.cost_average
            }
          }
          return res
        }, {})
      }
      // return result
      var col = 'date'
      var ascending = true
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return result.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    }
  },
  methods: {
    save () {
      var obj = {
        date: this.cost_date,
        company_no: this.company_no
      }
      this.$emit('getSyncData', obj)
    }
  }
}
</script>
